export default {
  only: {
    en: 'Only',
  },
  left: {
    en: 'Left',
  },

  textTop: {
    en: `
    To add your first {isMale, plural, one {cologne} other {perfume}}
    to the queue&nbsp;before&nbsp;it’s<br/>
    packed and shipped.
  `,
  },
  textBottom: {
    en: `
    Or keep your queue empty if you want to receive a
    {isMale, plural, one {cologne} other {perfume}}&nbsp;of&nbsp;the&nbsp;month.<br />
    You can always come to the website and update&nbsp;your&nbsp;queue.
  `,
  },

  buttonWomen: {
    en: 'Add perfumes to queue',
  },
  buttonMen: {
    en: 'Add colognes to queue',
  },
}
